import { api } from "./client";
import type { User } from "@/types";

// Login/logout sont centralisés sur compte.orense.ch (cf. @/auth/sso).
// PL ne conserve que la lecture de l'état de session.
export const getMe = () => api.get<User>("/api/auth/me");
